<template>
  <!-- Search Area -->
  <el-row :gutter="10" class="search-area">
    <el-col :span="14">
      <el-row :gutter="10">
        <!-- <el-col :span="3" v-if="!isHideCategory">
          <el-select v-model="onSearch.period">
            <el-option v-for="item in periodList" :label="item.title" :key="item.value" :value="item.value"></el-option>
          </el-select>
        </el-col> -->
        <el-col :span="10" v-if="!isHideDate">
          <CommDatePicker v-model="onSearch.date" :value.sync="onSearch.date" width="100%" type="daterange"
            :showWeekly="true" format="yyyy-MM-dd" @change="formatTimeStamp" :picker-options="{
              shortcuts: [
              {
                  text: '全て',
                  onClick(picker) {
                    const start = null;
                    const end = null;
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '過去7日',
                  onClick(picker) {
                    const start = $moment().subtract(7, 'day').startOf('day').valueOf()
                    const end = $moment().endOf('day').valueOf()
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '過去1月',
                  onClick(picker) {
                    const start = $moment().subtract(1, 'month').startOf('day').valueOf()
                    const end = $moment().endOf('day').valueOf()
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '過去3月',
                  onClick(picker) {
                    const start = $moment().subtract(3, 'month').startOf('day').valueOf()
                    const end = $moment().endOf('day').valueOf()
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '過去1年',
                  onClick(picker) {
                    const start = $moment().subtract(1, 'year').startOf('day').valueOf()
                    const end = $moment().endOf('day').valueOf()
                    picker.$emit('pick', [start, end]);
                  }
                }
              ]
            }" />
        </el-col>
        <el-col :span="7">
          <el-input :placeholder="$locale('cinemaWebsite.custom.plsInputContent')" v-model="onSearch.title"
            @keyup.enter.native="filter_fn" clearable>
            <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button class="egl-btn-yellow cinema-website " @click="filter_fn">{{
            $locale("global.search")
          }}</el-button>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="ta-r" :span="10">
      <el-button class="egl-btn-yellow" @click="create_fn">{{ $locale("cinemaWebsite.custom.create") }}</el-button>
    </el-col>
  </el-row>
</template>
<script>
import CommDatePicker from "@/components/common/CommDatePicker";

export default {
  props: {
    isHideCategory: {
      type: Boolean,
      default: false,
    },
    isHideDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      onSearch: {
        date: "",
        title: "",
      },
    }
  },
  computed: {
    searchObj() {
      const { date, title } = this.onSearch;
      return {
        ...date && Array.isArray(date) && date[0] ? {
          startTime: date[0]
        } : {},
        ...date && Array.isArray(date) && date[1] ? {
          endTime: date[1]
        } : {},
        ...title ? {
          keyword: title,
        } : {}
      }
    }
  },
  methods: {
    filter_fn() {
      this.$emit('filter', this.searchObj);
    },
    create_fn() {
      this.$emit('create');
    },
    formatTimeStamp(value) {
      const [ start, end ] = value;
      this.onSearch.date[0] = this.$moment(start).startOf("day").valueOf();
      this.onSearch.date[1] = this.$moment(end).endOf("day").valueOf();
    }
  },
  components: {
    CommDatePicker,
  },
}
</script>